import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import Avatar from 'material-ui/Avatar'
import Menu, { MenuItem } from 'material-ui/Menu';

import * as login from '../../actions/userdetails'
import * as customerdetails from '../../actions/customerdetails'
import * as fileupload from '../../actions/fileupload'

import ChangePassword from './changepassword'
import ChangeRole from './changerole'
class UserInfo extends React.Component {

    state = {
        valueSetPhoto: false,
        anchorEl: null,
        open: false,
        openDialog: false,
        openDialogRole: false,
        loginUserPhoto: null,
        isChangePassword: false,
        isChangeRole: false,
    };

    handleClick = event => {
        this.setState({ open: true, anchorEl: event.currentTarget });
    };

    handleRequestClose = () => {
        this.setState({ open: false });
    };

    handleChangePassword = () => {
        this.setState({ open: false });
        this.setState({ openDialog: true });
    };
    handleSetChangePassword = () => {
        this.setState({ isChangePassword: true });
    };

    handleChangeRole = () => {
        this.setState({ open: false });
        this.setState({ openDialogRole: true });
    };
    handleSetChangeRole = () => {
        this.setState({ isChangeRole: true });
    };

    handleLogout = () => {
        this.props.actions.logout();
        this.props.history.push('/login');
    };

    closeDialog = (data) => {
        this.setState({ openDialog: false, openDialogRole: false, isChangePassword: false, isChangeRole: false });
    }

    componentDidMount() {
        const { loginUser } = this.props;
        // console.log('photoDownloadLoggedInUser componentDidMount', loginUser)
        this.state.loginUserPhoto = null;
        if (loginUser && loginUser.data && loginUser.data.user_id) {
            this.props.actions.photoDownloadLoggedInUser(loginUser.data.user_id);
        }
        this.props.actions.getIsCheckerOrADEnabled();
    }
    render() {
        const { loginUser, userDetails } = this.props;
        // console.log('UserInfo this.props:', this.props)
        let username = null;
        if (loginUser && loginUser.data && loginUser.data.user_name)
            username = loginUser.data.user_name;
        // console.log('loginUser', loginUser)
        if (loginUser && loginUser.loginUserPhoto && !this.state.loginUserPhoto) {
            // console.log('After upload success',this.state.newfile)
            this.state.loginUserPhoto = loginUser.loginUserPhoto;
            this.setState({ valueSetPhoto: false });
            // console.log('After upload success', this.state.user)
        }
        if (this.state.isChangePassword && !userDetails.CPStatus && userDetails.CPResult) {
            this.setState({ openDialog: false, isChangePassword: false });
        }
        if (this.state.isChangeRole && !userDetails.CPStatus && userDetails.CPResult) {
            this.setState({ openDialogRole: false, isChangeRole: false });
            this.props.history.push('/dashboard')
        }
        return (
            <div className="user-profile d-flex flex-row align-items-center">
                <Avatar
                    alt='...'
                    // src='http://via.placeholder.com/256x256'
                    src={this.state.loginUserPhoto && this.state.loginUserPhoto != -1 ? "data:image/png;base64, " + this.state.loginUserPhoto : 'ProfilePic.png'}
                    className="user-avatar "
                />
                <div className="user-detail">
                    <h4 className="user-name" onClick={this.handleClick}>{username}<i
                        className="zmdi zmdi-caret-down zmdi-hc-fw align-middle" />
                    </h4>
                </div>
                <Menu className="user-info d-flex"
                    id="simple-menu"
                    anchorEl={this.state.anchorEl}
                    open={this.state.open}
                    onClose={this.handleRequestClose}
                    PaperProps={{
                        style: {

                        }
                    }}
                >
                    {/* <MenuItem onClick={this.handleRequestClose}><i
                        className="zmdi zmdi-account zmdi-hc-fw mr-2" />
                        Profile </MenuItem>
                    <MenuItem onClick={this.handleRequestClose}><i
                        className="zmdi zmdi-settings zmdi-hc-fw mr-2" />Setting
                    </MenuItem> */}
                    <MenuItem onClick={this.handleChangePassword}><i
                        className="zmdi zmdi-lock  zmdi-hc-fw mr-2" />Change Password
                    </MenuItem>
                    <MenuItem onClick={this.handleChangeRole}><i
                        className="zmdi zmdi-accounts-alt  zmdi-hc-fw mr-2" />Change Role
                    </MenuItem>
                    <MenuItem onClick={this.handleLogout}><i
                        className="zmdi zmdi-sign-in zmdi-hc-fw mr-2" />Logout
                    </MenuItem>
                </Menu>
                <ChangePassword open={this.state.openDialog} loginUser={this.props.loginUser}
                    closeDialog={this.closeDialog} handleSetChangePassword={this.handleSetChangePassword} />
                <ChangeRole open={this.state.openDialogRole} loginUser={this.props.loginUser}
                    closeDialog={this.closeDialog} handleSetChangeRole={this.handleSetChangeRole} />
            </div>
        );
    }
}

const mapStateToProps = ({ loginUser, userDetails }) => {
    return { loginUser, userDetails }
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, fileupload, login, customerdetails), dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserInfo));




// WEBPACK FOOTER //
// ./components/UserInfo/index.js